<template>
  <div class="edit-base-shelf-item">
    <div class="edit-shelfname-label">{{ title }}</div>
    <el-select class="shelfcover-select" size="mini" v-model="coverOption">
      <el-option v-for="item in coverSettingOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <input type="file" id="shelfCoverUpload" ref="uploadCover" value="imgFile" accept="image/png, image/jpg, image/jpeg" @change="chooseImg($event)" style="display:none" />
    <label v-if="coverOption === 1" for="shelfCoverUpload">
      <div class="upload-cover-button">上传封面</div>
    </label>
    <img v-if="coverOption === 1" class="cover-box" :src="currentCover" alt="图片不在" />
  </div>
</template>

<script>
import apis from '@api/setBook'
export default {
  name: 'shelfCover',
  data() {
    return {}
  },
  props: ['type'],
  computed: {
    coverSettingOptions() {
      return [
        {
          value: 0,
          label: '最新上传作品封面'
        },
        {
          value: 1,
          label: '自定义' + this.title
        }
      ]
    },
    title() {
      return this.type === 'bookShelf' ? '专辑封面' : '图书馆封面'
    },
    currentCover: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].currentCover || require('@imgs/bookshelfedit/shelf_edit_cover.png')
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COVER', { type: this.type + 'Obj', key: 'currentCover', value: value })
      }
    },
    coverOption: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].coverOption
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_COVER', { type: this.type + 'Obj', key: 'coverOption', value: value })
      }
    }
  },
  methods: {
    chooseImg(e) {
      const file = e.target.files[0]
      if (!/\.(jpg|png|JPG|PNG)$/.test(e.target.value)) {
        this.$message({
          message: '请上传jpg或png格式图片',
          duration: 3000,
          center: true,
          type: 'warning'
        })
        return false
      }
      if (file.size > 1024 * 1024) {
        this.$message({
          message: '封面图过大，影响加载体验，请选择小于1M的图片',
          duration: 3000,
          center: true,
          type: 'error'
        })
        return
      }

      this.uploadImg(file)
    },
    uploadImg(file) {
      let params = new FormData()
      const payload = this.type === 'bookLib' ? 'libCover' : 'albumCover'
      params.append('fieldName', payload)
      params.append(payload, file)
      apis.uploadPicture(params).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.$store.commit('config/UPDATE_COVER', { type: this.type + 'Obj', key: 'cover', value: res.data.data })
          const url = window.URL.createObjectURL(file)
          this.currentCover = url
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-cover-button {
  width: 78px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: #df5813;
  color: #ffffff;
  border-radius: 10px;
  margin: 12px 0;
  font-size: 12px;
  cursor: pointer;
}
.cover-box {
  width: 120px;
  height: 75px;
  object-fit: contain;
  border: 1px dashed #979797;
}
</style>
